/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import { faCheckCircle, faInfoCircle, faExclamationCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const statusToIcon = {
    'success': faCheckCircle,
    'info': faInfoCircle,
    'warning': faExclamationTriangle,
    'danger': faExclamationCircle
};


// WEBPACK FOOTER //
// ./src/status.js